export const ConfigConstants = {
    CAS_SERVICE_URL: "CAS_SERVICE_URL",
    CAS_CLIENT_ID: "CAS_CLIENT_ID",
    DIY_TAX_APP_2022_URL: "DIY_TAX_APP_2022_URL",
    DIY_TAX_APP_2021_URL: "DIY_TAX_APP_2021_URL",
    DIY_TAX_APP_2020_URL: "DIY_TAX_APP_2020_URL",
    DIY_TAX_APP_2019_URL: "DIY_TAX_APP_2019_URL",
    DIY_TAX_APP_2018_URL: "DIY_TAX_APP_2018_URL",
    DIY_TAX_APP_2017_URL: "DIY_TAX_APP_2017_URL",
    DIY_TAX_APP_2016_URL: "DIY_TAX_APP_2016_URL",
    VIRTUAL_ASSIST_URL: "VIRTUAL_ASSIST_URL"
};